module.exports = __webpack_public_path__ + "static/media/provider-um-icon.4019ee2a.svg";